import { Box, Skeleton as MuiSkeleton, Stack } from '@mui/material';

const SKELETON_MAX_WIDTH = 1184;

const CardSkeleton = () => (
  <Box sx={{ flex: { xs: '0 0 168px', md: '1 1 0' }, minWidth: 0 }}>
    <MuiSkeleton variant="rounded" sx={{ width: '100%', height: { xs: 140, md: 200 }, mb: 2 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '80%', height: 16, mb: 1 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '40%', height: 12 }} />
  </Box>
);

const SectionSkeleton = () => (
  <Box>
    <MuiSkeleton variant="rounded" sx={{ width: 160, height: 24, mb: 4, mx: { xs: 5, md: 0 } }} />
    <Box sx={{ display: 'flex', gap: { xs: 3, md: 6 }, overflow: 'hidden', px: { xs: 5, md: 0 } }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </Box>
  </Box>
);

export const InsightsPageSkeleton = () => (
  <Box maxWidth={SKELETON_MAX_WIDTH} mx="auto" sx={{ py: 5 }}>
    <Box sx={{ display: 'flex', gap: 2, mb: { xs: 6, lg: 10 }, overflow: 'hidden', px: { xs: 5, md: 0 } }}>
      {Array.from({ length: 6 }).map((_, i) => (
        <MuiSkeleton
          key={i}
          variant="rounded"
          sx={{ width: { xs: 72, md: 96 }, height: 36, borderRadius: '40px', flexShrink: 0 }}
        />
      ))}
    </Box>
    <Stack gap={{ xs: 10, md: 18 }}>
      {Array.from({ length: 3 }).map((_, i) => (
        <SectionSkeleton key={i} />
      ))}
    </Stack>
  </Box>
);
